/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useState } from "react"
import { SuccessFetch } from "types"
import { useApi } from "utils"

type UserSohParam = {
  location_id: number
  product_id: number
}

type Response = {
  payload: {
    soh: number
  }
}

export function useSohByProduct({
  location_id,
  product_id
}: UserSohParam) {
  const api = useApi()
  const [data, setData] = useState<{ soh: number }>({ soh: 0 })
  const [isLoading, setLoading] = useState(false)
  const fetchData = () => {
    setLoading(true)

    api
      .get("/transfer/get_soh_by_product_location", { params: { location_id  , product_id } })
      .then((res: SuccessFetch<Response>) => {
        const data = res.data.payload ?? []
        setData(data)
      })
      .catch(() => setData({ soh: 0 }))
      .finally(() => setLoading(false))
  }

  const refetch = () => fetchData()

  useEffect(() => {
    if (location_id && product_id) {
      fetchData()
    }

    return () => {
      setData({ soh: 0 })
      setLoading(false)
    }
  }, [location_id, product_id])

  return {
    data,
    isLoading,
    refetch
  }
}
